import * as React from "react"
import {Button, Modal} from "semantic-ui-react"

import {BookingGutsFragment, CancelBooking as CANCEL_BOOKING} from "../graphql/queries"
import {ID} from "../model/id"
import {errorUnionToEither, OrError} from "../graphql/errors"
import {WithModalStore} from "../App"
import {GraphQL} from "../graphql"

export interface Props extends WithModalStore {
  id: ID
  message: string
}

export function CancelBookingModal(props: Props) {
  const {modalStore, message} = props

  return (
    <Modal dimmer="blurring" size="small" open={true} closeOnDimmerClick={false}>
      <Modal.Header>Cancel Booking</Modal.Header>
      <Modal.Content>
        <p>{message}</p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onDismiss}>Return to booking</Button>
        <Button
          negative
          onClick={() => {
            modalStore.handlePromiseThrow(onConfirm())
          }}
        >
          Cancel Booking
        </Button>
      </Modal.Actions>
    </Modal>
  )

  async function onConfirm() {
    await modalStore.applyModal({
      pending: ["Cancelling booking", "Cancelling booking..."],
      ok: () => ["Booking cancelled", "Your booking has now been cancelled."],
      error: (m) => ["Cancel failure", m],
      async action() {
        return onCancelBooking()
      },
    })
  }

  function onDismiss() {
    modalStore.hideModal()
  }

  async function onCancelBooking(): Promise<OrError<BookingGutsFragment>> {
    const data = await GraphQL.mutate(CANCEL_BOOKING, {id: props.id})
    return errorUnionToEither(data.cancelBooking)
  }
}



// WEBPACK FOOTER //
// ./src/components/CancelBookingModal.tsx